import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";
import { formatLength } from "../../../../../constants";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";

const QTDetailsInteractionsFieldsSection = ({
  quicktaleDetails,
}) => {
  return (
    <Grid container style={interactionsContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*# of likes section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Likes"}
          value={
            quicktaleDetails?.likedBy ? quicktaleDetails?.likedBy?.length : 0
          }
          disabled={true}
        />
        {/*# of Reactions section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Reactions"}
          value={
            quicktaleDetails?.reactions
              ? quicktaleDetails?.reactions?.length
              : 0
          }
          disabled={true}
        />
        {/*length section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Length"}
          value={
            quicktaleDetails?.audioLength &&
            formatLength(quicktaleDetails?.audioLength)
          }
          disabled={true}
        />
        {/*creation date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Creation Date"}
          value={
            quicktaleDetails?.createdAt &&
            moment
              .unix(quicktaleDetails?.createdAt?.seconds)
              .format("MM-DD-YYYY HH:mm:ss")
          }
          disabled={true}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*# of Saves section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Saves"}
          value={
            quicktaleDetails?.noOfSaves
              ? quicktaleDetails?.noOfSaves?.length
              : 0
          }
          disabled={true}
        />
        {/*# of Shares section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"# of Shares"}
          value={
            quicktaleDetails?.sharedWithUsers
              ? quicktaleDetails?.sharedWithUsers?.length
              : 0
          }
          disabled={true}
        />
        {/*Original Audio File name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Original Audio File Name"}
          value={quicktaleDetails?.originalAudioName}
          disabled={true}
        />
        {/*Original Photo File name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Original Photo File Name"}
          value={quicktaleDetails.originalPhotoName}
          disabled={true}
        />
      </Grid>
    </Grid>
  );
};

export default QTDetailsInteractionsFieldsSection;

const interactionsContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginTop: 20,
  marginBottom: 100,
};
